<template>
  <div class="shadow">
    <activity-stack-navigator v-if="login"></activity-stack-navigator>
    <b-navbar id="dark-navbar" toggleable="none" type="dark" variant="dark" fixed="true"
              class="shadow gradient-dark p-2"
              style="z-index: 1000; position: fixed; width: 100%; top: 0; max-height: 56px; align-items: center; flex-wrap: nowrap">

      <!--open/hide mobile button-->
      <b-button v-if="login" class="mr-3 d-block d-md-none" @click="toggleMenu" id="left-menu-toggle-button"
                @focusOut="checkFocus"
                ref="toggleButton" data-test-path="desktop-left-menu-toggle"
                :variant="leftMenuVisible?  'plm-primary-light' : 'plm-outline-primary'"
                style="height: 35px">
        <font-awesome-icon icon="bars" class="fa-lg"></font-awesome-icon>
      </b-button>

      <!--open/hide desktop button-->
      <button v-if="login" type="button" class="btn mr-3 btn-plm-outline-primary d-none d-md-flex"
              @click="showHideLeftMenu" id="desktop-left-menu-toggle-button"
              data-test-path="left-menu-toggle"
              style="height: 35px">
        <font-awesome-icon icon="bars" class="fa-lg"></font-awesome-icon>
      </button>

      <ImageViewer
          style="margin: 0  !important"
          v-if="organizationForm.navigationBarImage.value"
          :src="organizationForm.navigationBarImage.value.url"
          :min-height="25"
          :max-height="40"
          :max-width="70"
      >
      </ImageViewer>
      <b-navbar-brand style="white-space: normal !important;" v-else-if="organizationForm.shortName.value">{{ organizationForm.shortName.value }}
      </b-navbar-brand>
      <b-navbar-brand v-else>
        <img class="app-logo" src="https://www.silkplm.com/wp-content/uploads/2024/04/logo-SilkPLM_bialy_small.png"
             alt="Silk PLM">
        <!--        <img :src="logo" alt="SilkPLM Logo">-->
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <div class="form-inline">
          <div class="d-none d-md-inline-block" v-if="login">
            <smart-search></smart-search>
          </div>

          <b-nav-item @click="clickOnStickyNoteIcon" v-if="login" class="d-block  mr-3" link-classes="py-0">
            <StickyNoteIcon
                v-if="false"
                @click-on-sticky-note-icon="clickOnStickyNoteIcon"
                class="mr-2 ml-2"
                data-test-path="sticky-note-menu-toggle"
                :sticky-note-menu-visible="stickyNoteMenuVisible"
            >
            </StickyNoteIcon>
          </b-nav-item>

          <b-nav-item v-if="login" class="d-block" link-classes="py-0 pr-2">
            <Bell
                data-test-path="notification-bell"
                :bell-menu-visible="bellMenuVisible"
                :user-menu-visible="userMenuVisible"
                :sticky-note-menu-visible="stickyNoteMenuVisible"
                @hide-bell="hideBellMenu"
                @show-bell="showBellMenu"
                @hide-user-menu="hideUserMenuPanel"
            >
            </Bell>
          </b-nav-item>
          <b-nav-item v-if="login" class="d-block  mr-3" link-classes="py-0">
            <font-awesome-icon
                data-test-path="right-menu-toggle"
                @click="clickOnMyAccount"
                icon="user"
                class="fa-xl "

            />
          </b-nav-item>
        </div>
      </b-navbar-nav>
    </b-navbar>

    <div class="notifications" style="z-index: 1020" v-if="login">
      <MyAccount
          :bell-menu-visible="bellMenuVisible"
          :user-menu-visible="userMenuVisible"
          :sticky-note-menu-visible="stickyNoteMenuVisible"
          @hide-bell="hideBellMenu"
          @hide-sticky-note-menu="hideStickyNoteMenu"
          @hide-user-menu="hideUserMenuPanel"
          @show-user-menu="showUserMenuPanel"
      >
      </MyAccount>
      <BellNotification
          @hide-bell="hideBellMenu"
          :bell-menu-visible="bellMenuVisible">
      </BellNotification>

      <StickyNoteMenu
          v-if="false"
          :bell-menu-visible="bellMenuVisible"
          :sticky-note-menu-visible="stickyNoteMenuVisible"
          :user-menu-visible="userMenuVisible"
          @hide-bell="hideBellMenu"
          @hide-sticky-note-menu="hideStickyNoteMenu"
          @show-sticky-note-menu="showStickyNoteMenu"
          @show-sticky-notes="showOrHideStickyNotesList"
          @hide-user-menu="hideUserMenuPanel"
      ></StickyNoteMenu>

      <PopupNotification></PopupNotification>

    </div>
    <div class="notifications w-100"  style="z-index: 1000; top:56px !important; right:0px !important;">
        <MaintenanceNotice></MaintenanceNotice>
    </div>

    <div class="px-0 mx-0 " id="left-navbar-panel"
         style=" height: 100vh;
                      position: fixed;
                      top: 0;
                      padding-top: 56px;
                      left: 0;
                      z-index: 1020">
      <LeftMenu v-model="leftMenuVisible" v-if="login" ref="leftMenu"></LeftMenu>
    </div>

    <ListOfStickyNotes v-if="login" :sticky-note-list-visible="stickyNoteListVisible"></ListOfStickyNotes>

  </div>
</template>

<script>
import SessionManager from "@/utils/SessionManager"
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import LeftMenu from "@/components/dashboard/menu/LeftMenu";

import Bell from "@/components/notifications/Bell";
import BellNotification from "@/components/notifications/BellNotification";
import PopupNotification from "@/components/notifications/PopupNotification";
import MaintenanceNotice from "@/components/notifications/MaintenanceNotice";
import MyAccount from "@/components/users/MyAccount";
import ImageViewer from "@/components/img/ImageViewer";
import OrganizationForm from "@/components/organization/OrganizationForm";
import SmartSearch from "@/components/dashboard/SmartSearch";
import Log from "@/utils/Log";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import {HotKeys, KeyPattern} from "@/utils/HotKeys";
import StickyNoteIcon from "@/components/sticky/StickyNoteIcon";
import ListOfStickyNotes from "@/components/sticky/ListOfStickyNotes";
import StickyNoteMenu from "@/components/dashboard/menu/StickyNoteMenu";
import ActivityStackNavigator from "@/activity/ActivityStackNavigator";


export default {
  name: "Navbar",
  components: {
    ActivityStackNavigator,
    ListOfStickyNotes,
    StickyNoteIcon,
    SmartSearch,
    LeftMenu, Bell, MyAccount, BellNotification, PopupNotification, ImageViewer, StickyNoteMenu, MaintenanceNotice
  },
  async beforeMount() {
    this.$onEvent(Events.organizationLogoChanged, () => {
      this.refreshLogo();
    });

    this.$onEvent(Events.userSignedIn, login => {
      this.login = login;
    });
    this.$onEvent(Events.userSignedOut, () => {
      this.login = "";
    });

    this.$onEvent(Events.showOrHideStickyNotesList, this.showOrHideStickyNotesList);

    if (SessionManager.isLoggedIn()) {
      this.login = SessionManager.login;
      await this.organizationForm.refresh();
    } else {
      this.login = '';
    }
  },
  async mounted() {
    HotKeys.register(new KeyPattern(" ", true), () => {
      this.$refs.toggleButton.focus();
      setTimeout(() => {
        this.toggleMenu();
        this.$refs.toggleButton.focus();
      });
    });

    let that = this;
    let escListener = (e) => {
      if (e.key === "Escape") {
        if (document.getElementById("nav-left-menu").classList.contains("show")) {
          that.$root.$emit('bv::toggle::collapse', "nav-left-menu");
        }
      }
    }

    let listener = (e) => {
      if (document.getElementById("nav-left-menu").classList.contains("show")) {
        let layer = e.target;
        let onMe = false;
        let body = document.getElementsByTagName("body")[0];
        let me = document.getElementById("nav-left-menu");
        let toggle = that.$refs['toggleButton'];

        let limit = 500;
        for (let i = 0; i < limit; i++) {
          if (layer == toggle.$el) {
            onMe = true;
            break
          }
          if (layer == me) {
            onMe = true;
            break
          }
          if (layer == body) {
            break;
          }
          if (i == limit - 1) {
            Log.warn("Click scan limit reached");
          }
          layer = layer.parentElement;
        }
        if (!onMe) {
          that.$root.$emit('bv::toggle::collapse', "nav-left-menu");
        }
      }
    };

    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId == "nav-left-menu") {
        if (isJustShown) {
          document.body.addEventListener("click", listener, {capture: true})
          window.addEventListener("keydown", escListener);
        } else {
          document.body.removeEventListener("click", listener, {capture: true})
          window.removeEventListener("keydown", escListener);
        }
      }
    });

    if (this.login.length) {

    }
  },
  methods: {

    showHideLeftMenu() {
      EventBus.$emit(Events.showHideLeftMenu);
    },

    checkFocus() {
      this.$refs.leftMenu.checkFocus();

    },
    toggleMenu() {
      this.$refs.leftMenu.toggle();
    },
    async refreshLogo() {
      await this.organizationForm.refresh();
    },
    signOut() {
      SessionManager.signOut();
    },

    clickOnMyAccount() {
      EventBus.$emit(Events.clickedOnMyAccount);
    },

    clickOnStickyNoteIcon() {
      EventBus.$emit(Events.clickedOnStickyNotes);
    },

    hideBellMenu() {
      this.bellMenuVisible = false;
    },
    showBellMenu() {
      this.bellMenuVisible = true;
    },
    hideUserMenuPanel() {
      this.userMenuVisible = false;
    },
    showUserMenuPanel() {
      this.userMenuVisible = true;
    },
    hideStickyNoteMenu() {
      this.stickyNoteMenuVisible = false;
    },
    showStickyNoteMenu() {
      this.stickyNoteMenuVisible = true;
    },
    showOrHideStickyNotesList() {
      this.stickyNoteListVisible = !this.stickyNoteListVisible;
    },


  },
  data: () => ({
    leftMenuVisible: false,
    organizationForm: new OrganizationForm(),
    login: "",
    width: 0,
    bellMenuVisible: false,
    userMenuVisible: false,
    stickyNoteMenuVisible: false,
    stickyNoteListVisible: false,
    stuckStickyNoteVisible: false,
    // logo: require('@/assets/images/logo-white-small.png')
  })
}
</script>

<style>
.app-logo {
  width: 93px;
  height: auto;
}
</style>
